import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MetricRankingsService } from './metric-rankings.service';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MetricsService {

  private metricsSource = new BehaviorSubject<Metric[]>(null);
  currentMetrics = this.metricsSource.asObservable();

  constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient, private MetricRankingsService: MetricRankingsService) { }

  getMetrics() {
    this.http.get(`${this.baseUrl}api/Metrics`, {observe: 'response'}).subscribe(response => {
      if (response.status === 200) {
        let metrics: any = response.body;
        this.metricsSource.next(metrics);
      }
    });
  }

  // Not being used at the moment.
  // getMetricById(id: number) {
  //   this.http.get(`${this.baseUrl}api/Metrics/${id}`, {observe: 'response'}).subscribe(response => {
  //     if (response.status === 200) {
  //       console.log(response.body);
  //     }
  //   });
  // }

  putMetric(metric: Metric) {
    this.http.put(`${this.baseUrl}api/Metrics/${metric.metricId}`, metric, {observe: 'response'}).subscribe(response => {
      if (response.status === 201) {
        this.getMetrics();
      }
    });
  }

  postMetric(metric: any) {
    var rankingId = metric.rankingId;
    let data: any = {};
    data.metricName = metric.metricName;
    data.metricDescription = metric.metricDescription;
    data.metricDataTypeId = 1;
    this.http.post(`${this.baseUrl}api/Metrics`, data, {observe: 'response'}).subscribe(response => {
      if (response.status === 201) {
        this.getMetrics();
        let body: any = response.body;
        let metricId: number = body.metricId;
        let metricRankingData: any = {};
        metricRankingData.metricId = metricId;
        metricRankingData.rankingId = rankingId;
        let metricRankingExists = (metricRanking) => metricRanking.metricId === metricId;
        this.MetricRankingsService.currentMetricRankings
        .pipe(first())
        .subscribe(metricRankings => {
          if (!metricRankings.filter(metricRankingExists).length) {
            this.MetricRankingsService.postMetricRanking(metricRankingData);
          }
        });
      }
    });
  }

  deleteMetric(metricId: number, rankingId: number) {
    console.log(metricId);
    this.http.delete(`${this.baseUrl}api/Metrics/${metricId}`, { observe: 'response' }).subscribe(response => {
      if (response.status === 200) {
        this.MetricRankingsService.getMetricRankings(rankingId);
      }
    })
  }

  changeMetrics(metrics) {
    this.metricsSource.next(metrics);
  }
}

export interface Metric {
  metricId?: number,
  metricName: string,
  metricDescription: string,
  metricDataTypeId: number,
  metricDataTypeName?: string,
  sortOrder?: number,
  activeForNextRanking?: boolean
}
